/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description utils for parsing FHIR data types
 */

import _ from 'lodash';
import FHIR_SYSTEM_MAPPING from 'app-constants/eligibility/fhirSystemMapping.json';

// get identifier value using system
const getIdentifierValue = (identifierList: Fhir.Identifier[], system: string): string | undefined => {
	return _.find(identifierList, { system })?.value;
};

// get human name
const getHumanName = (names: Fhir.HumanName[]): string => {
	const firstItem = _.first(names);
	if (firstItem?.text) {
		return firstItem?.text;
	}
	const firstName = _.join(_.compact(firstItem?.given), ' ');
	const lastName = firstItem?.family || '';
	if (!firstName && !lastName) {
		return '';
	}
	return `${firstName} ${lastName}`;
};

// get name
const getName = (resource: any): string => {
	return _.isString(resource?.name) ? resource?.name : getHumanName(resource?.name);
};

const getFhirClaimStatus = (resource: any): string => {
	const fhirSystemMapping = FHIR_SYSTEM_MAPPING['STC-STC01-01'];
	const statusCodings = _.filter(_.get(resource, 'coding', []), { system: fhirSystemMapping });
	return _.first(statusCodings)?.code;
};

const getClaimStatus = (resource: any): string => {
	return _.isString(resource?.status) ? resource?.status : getFhirClaimStatus(resource);
};

export { getIdentifierValue, getName, getClaimStatus };
